.circle-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;

  filter: drop-shadow(0px 3px 5px rgba(50, 50, 0, 0.5));
  & img {
    clip-path: circle(25px at center);
  }

  &:hover {
    filter: drop-shadow(0px 3px 8px rgba(50, 50, 0, 0.5));
  }
}

.dropdown-menu {
  width: 160px;
  border-radius: 8px;
  background-color: var(--ds-background);
  right: 0;
  top: calc(100% + 10px);
}

.dropdown-choice {
  padding: 17px 24px;
  color: var(--ds-black);
  font-size: 16px;
  letter-spacing: 0.3px;
  line-height: 22px;
  &:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  &:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &:hover,
  &:focus {
    background-color: var(--ds-highlight);
  }
}

.arrow {
  margin-left: 4px;
}
